@if (isInputLike) {
  <div>
    <blaze-tags-column-value
      [value]="value"
      [fitToContainer]="true"
      [useExternalClickAction]="true"
      [isMultipleValue]="isMultiple"
      (clickAction)="externalClickAction($event)"
    />
  </div>
}

@if (!anyRecordsLoaded() && !isInputLike) {
  <button class="empty-list-notification border-a-12">
    <blaze-loading-indicator />
  </button>
}

@if (anyRecordsLoaded()) {
  <div #menuTrigger [matMenuTriggerFor]="menu"></div>
  <mat-menu #menu class="bd-menu inline-editor-link-menu tooltips-with-theme">
    <div class="searchbox">
      <input
        #filterInput
        [formControl]="searchFormCtrl"
        autocomplete="off"
        name="search-input"
        placeholder="Search existing value"
        class="p-12 rounded search-input"
        type="text"
        (click)="preventEventAction($event)"
      />
    </div>
    <div class="max-h-[320px] overflow-auto" (scroll)="scrollBottom($event)">
      @for (record of records(); track record) {
        <button mat-menu-item class="!h-auto" (click)="selectRecord($event, record)">
          @let recordValue = getRecordDisplayValue(record);
          <div class="record">
            @let isRecordValueVisible = !record?.tableHasExpandableLinks;
            @if (isRecordValueVisible) {
              <div class="record-value truncate" [blazeTooltip]="recordValue">
                {{ recordValue }}
              </div>
            }
            <div class="record-display" [class.fulldisplay]="!isRecordValueVisible">
              <div class="font-medium" [blazeTooltip]="recordValue || record.displayValue">
                @if (record?.otherLinkedValues?.length) {
                  <span class="!text-accent mr-3">*</span>
                }
                {{ recordValue || record.displayValue || getRecordLinkedValue(record.value) || '' }}
              </div>
              @if (record?.otherLinkedValues?.length) {
                <div class="flex gap-40">
                  @for (
                    linkedValues of record?.otherLinkedValues?.slice(0, 3);
                    track linkedValues
                  ) {
                    <div class="flex flex-col">
                      <div class="sub-label text-11 whitespace-nowrap">{{ linkedValues?.[0] }}</div>
                      <div class="truncate text-13 inline-block">
                        {{
                          getRecordDisplayValue(linkedValues?.[1]) ||
                            getRecordLinkedValue(linkedValues?.[1])
                        }}
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        </button>
      }
      @if (nextPageToken) {
        <div class="p-14">
          <blaze-loading-indicator />
        </div>
      }
      @if (!records().length) {
        <button class="empty-list-notification"> No values to select </button>
      }
    </div>
  </mat-menu>
}
